import React, { Fragment, useState } from 'react'
import { Grid, Tooltip, IconButton } from '@mui/material'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { apiCall, ApiConfig } from '../../../config/api'
import { OrderInfo } from '../../../interfaces/Order/Order'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { Loading } from '../../UI/Loading/Loading'
import { dynamicSort } from '../../../utils/helpers'
import Fade from '@mui/material/Fade'
import { plannerOT } from '../../../const/locationPaths'

export default function OrderDetailTab(
  item: any,
  index: any,
  expanded: any,
  setExpanded: any,
  locationPath: string,
  referenceId?: any
) {
  const [orderDetails, setOrderDetails] = useState<OrderInfo>()
  const [pageIndex, setPageIndex] = useState<number>(5)
  const [totalItems, setTotalItems] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [evt, setEvent] = useState<React.ChangeEvent<{}>>()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange =
    (panel: any, orderId: number) =>
    (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
      setEvent(event)
      setLoading(true)
      setOrderDetails(undefined)
      setExpanded(newExpanded ? panel : false)
      if (newExpanded) {
        setTimeout(
          () =>
            apiCall('GET', `${ApiConfig.OrderApi}/${orderId}`)
              .then((response) => {
                if (response.data.length !== 0) {
                  setLoading(false)
                  setOrderDetails(response.data)
                  setTotalItems(response.data.orderDetails.length)
                }
              })
              .catch((error) => {
                console.log(error)
                setLoading(false)
              }),
          500
        )
      } else {
        setExpanded(newExpanded ? panel : false)
        setLoading(false)
        setOrderDetails(undefined)
      }
    }

  return (
    <Fragment>
      <input
        type='hidden'
        value={
          evt?.target !== undefined ? evt.target.dispatchEvent.toString() : ''
        }
      ></input>
      <Grid
        container
        direction='row'
        spacing={2}
        justifyContent='center'
        alignItems='center'
        style={{
          display:
            referenceId !== item.split('/')[1] && locationPath === plannerOT
              ? 'none'
              : 'inline-block'
        }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <div>
            <div
              // expanded={expanded === `panel${index}`}
              // onChange={handleChange(
              //   `panel${index}`,
              //   parseInt(item.split('/')[0])
              // )}
            >
              <div
                // expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1bh-content'
                id='panel1bh-header'
              >
                <Typography>{`Pedido N° ${item.split('/')[1]}`} </Typography>
              </div>

              <div>
                {loading && <Loading />}
                {orderDetails !== undefined &&
                orderDetails.orderDetails.length > 0 ? (
                  <Fade in={true}>
                    <Grid
                      container
                      direction='row'
                      justifyContent='center'
                      alignItems='center'
                    >
                      <Grid item xs={12} sm={12} md={4}>
                        {'SKU/EAN'}
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        {'Descripción'}
                      </Grid>
                      <Grid item xs={12} sm={12} md={2}>
                        {'Cantidad'}
                      </Grid>

                      {orderDetails.orderDetails
                        .slice(0, pageIndex)
                        .sort(dynamicSort('name'))
                        .map((item) => {
                          return (
                            <Fragment>
                              <Grid item xs={12} sm={12} md={4}>
                                {item.sku.ean13 === item.sku.sku
                                  ? item.sku.sku
                                  : `${item.sku.sku}/${item.sku.ean13}`}
                              </Grid>
                              <Grid item xs={12} sm={12} md={6}>
                                {item.sku.name}
                              </Grid>
                              <Grid item xs={12} sm={12} md={2}>
                                {item.quantity}
                              </Grid>
                            </Fragment>
                          )
                        })}
                      {totalItems > pageIndex ? (
                        <Tooltip title='Más...' aria-label='masDetalle'>
                          <IconButton
                            onClick={() => {
                              if (pageIndex + 5 > totalItems) {
                                setPageIndex(totalItems)
                              } else {
                                setPageIndex(pageIndex + 5)
                              }
                            }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </Tooltip>
                      ) : pageIndex >= totalItems ? (
                        <Tooltip title='Ocultar...' aria-label='ocultarDetalle'>
                          <IconButton
                            onClick={() => {
                              if (pageIndex === totalItems) {
                                setPageIndex(5)
                              } else {
                                setPageIndex(pageIndex - 5)
                              }
                            }}
                          >
                            <ExpandLessIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        ''
                      )}
                    </Grid>
                  </Fade>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  )
}
